import { AddressLink, CreatePoolArgs } from 'Modules'
import { parseEventLogs } from 'viem'

import abiPTODistribution from 'abi/abi-pto-distribution.json'
import { SettingEnum } from 'constants/setting'
import { useContractViem } from 'hooks/contract/use-contract-viem'
import { useAppSetting } from 'hooks/setting/use-app-setting'
import { useContractManager } from 'hooks/use-contract-manager'
import { clientWallet, publicWallet } from 'libs/viem/config'
import { parserPercentContract, parserUnitContract } from 'utils/contract'
import { logError } from 'utils/logger'

/**
 * PTO v2 - list a collection for sale via PTODistribution.createPool.
 */
export const useCreatePool = () => {
  const { getSetting } = useAppSetting()

  const ptoDistributionContract = getSetting(SettingEnum.PTO_DISTRIBUTION_CONTRACT)

  console.log('ptoDistributionContract', ptoDistributionContract)

  const contract = useContractViem(ptoDistributionContract, abiPTODistribution)

  const { isContractManager } = useContractManager({ contract })

  const createPool = async (address: AddressLink, input: CreatePoolArgs) => {
    if (!ptoDistributionContract || !contract) {
      throw new Error('PTO Distribution contract is not configured')
    }
    if (!address || !input?.ptoAddress) return null

    try {
      const args = [
        parserUnitContract(input.pricePerNFT),
        input.tradeUnlockTime || 0,
        input.ptoAddress,
        parserPercentContract(input.buyingFeeBP),
        input.phases,
        input.nftRarities,
      ]

      console.log('args', args)
      const { request } = await contract.simulate.createPool(args, {
        account: address,
      })
      const txHash = await clientWallet?.writeContract(request)

      const receipt = await publicWallet.waitForTransactionReceipt({
        hash: txHash,
        confirmations: 1,
      })

      console.log('receipt', receipt)
      const logs: any = parseEventLogs({
        abi: abiPTODistribution,
        logs: receipt.logs,
        eventName: 'PoolCreated',
      })

      if (logs.length > 0) {
        return Number(logs[0].args.poolId)
      }

      // Fallback: read the latest poolId of the collection from the contract
      const poolIdsRes = await contract.read.getPoolIds([input.ptoAddress])
      if (poolIdsRes?.length) {
        return Number(poolIdsRes[poolIdsRes.length - 1])
      }
      return null
    } catch (error) {
      logError('error create pool v2-----------------', error)
      throw error
    }
  }

  return {
    isContractManager,
    createPool,
  }
}
